export default "__VITE_ASSET__$3CTfr1O__"